import { useFormik } from "formik";
import OtpInputField from "../../../molecules/formControls/inputField/OtpInputField";
import DefaultButton from "../../../atoms/buttons/DefaultButton";
import { otpValidationSchema } from "./validations";
import { useTranslation } from "react-i18next";

const OneTimePasswordForm = ({ onSubmit }) => {
  const { t } = useTranslation();

  const formik = useFormik({
    initialValues: { otp: "" },
    validationSchema: otpValidationSchema,
    onSubmit: async (values) => {
      await onSubmit(values);
    },
  });

  return (
    <form
      onSubmit={formik.handleSubmit}
      className="flex flex-col items-center gap-8"
    >
      <OtpInputField
        value={formik.values.otp}
        onValueChange={(val) => formik.setFieldValue("otp", val)}
      />
      <DefaultButton
        type="submit"
        label={t("oneTimePasswordForm.verifyButton")}
        disabled={!(formik.isValid & formik.dirty) || formik.isSubmitting}
      />
    </form>
  );
};

export default OneTimePasswordForm;
